export default {
    'common': {
        'termsCondition': 'Chính sách Giải quyết Khiếu nại',
        'privacyPolicy': 'Chính sách bảo mật',
        "selectLang": "VI",
        'register': 'Đăng ký',
        'login': 'Đăng nhập',
        'vietnamese': 'Tiếng việt',
        'english': 'Tiếng anh',
        'notification': 'Thông báo',
        'logout': 'Đăng xuất',
        'viewMore': 'Xem thêm',
        'save': 'Lưu',
        'requiredFields': 'Thông tin này là bắt buộc!',
        'search': 'Tìm kiếm',
        'loading': 'Đang tải',
        'networkError': "Lỗi mạng!",
        'nonumber': 'STT',
        'totalVoucher': 'Tổng cộng: {num} voucher(s)',
        'notificationToast': {
            'passwordIncorrect': 'Mật khẩu không khớp',
            'success': 'Thành công!',
            'errorVerification': 'Mã xác nhận không chính xác !',
            'oldPasswordInCorrect': 'Mật mật khẩu cũ không chính xác',
            'youAreMissingInformation': 'Bạn điền thiếu thông tin',
            'emailIsIncorrect': 'Email không đúng định dạng',
            'incorrectTelephoneNumber': 'Số điện thoại không đúng định dạng',
            'incorrectDateOfBirth': 'Ngày sinh không đúng định dạng',
            'pleaseEnterANewPassword': 'Vui lòng nhập mật khẩu mới!',
            'pleaseConfirmYourNewPassword': 'Vui lòng xác nhận mật khẩu mới!'
        },
        'changePassword': 'Đổi mật khẩu',
        'registerToBecomeSupplier': 'Trở thành nhà cung cấp?',
        'close': 'Đóng',
        'help': 'Hướng dẫn',
        'start': 'Bắt Đầu',
        'back': 'Quay lại',
        'tools': 'Công cụ',
        'sendEmail': 'Gửi email',
        'sendSelected': 'Gởi email {num} voucher đã chọn',
        'sendAll': 'Gửi tất cả',
        'language': 'Ngôn ngữ',
        'agree': 'Đồng ý',
        'cancel': 'Huỷ',
        'chooseAll': 'Chọn tất cả',
        'detail': 'Chi tiết',
        'loginWithGoogle': 'Đăng nhập với Google',
        'googleAccountLink': 'Liên kết Google',
        'facebookAccountLink': 'Liên kết Facebook',
        'loginWithFacebook': 'Đăng nhập với Facebook',
        'confirm': 'Xác Nhận'
    },
    'menu': {
        'home': 'Trang chủ',
        'voucherList': 'Danh sách voucher',
        'voucherWaitForConfirm': 'Danh sách voucher chờ xác nhận',
        'news': 'Tin tức',
        'myVoucher': 'Voucher',
        'lookupVoucher': 'Tra cứu',
        'guide': 'Hướng Dẫn',
        'transferVoucher': 'Chuyển voucher'
    },
    'register': {
        'title': 'Đăng ký tài khoản',
        'entityAlreadyExistWithTypeNotCustomer': 'Email đã tồn tại đơn vị với loại không phải khách hàng',
        'entityIsAlreadyExistWithAnotherUser': 'Email đã tồn tại đơn vị với người dùng khác',
        'username': 'Tên tài khoản',
        'email': 'Địa chỉ email',
        'password': 'Mật khẩu',
        'confirmPassword': 'Xác nhận mật khẩu',
        'oldPassword': 'Mật khẩu cũ',
        'newPassword': 'Mật khẩu mới',
        'fullName': 'Họ và tên',
        'phone': 'Điện thoại',
        'gender': 'Giới tính',
        'dateOfBirth': 'Ngày sinh',
        'address': 'Địa chỉ',
        'haveAnAccount': 'Đã có tài khoản?',
        'registerWithGoogle': 'Đăng ký với google'
    },
    'login': {
        'loginInvalid': 'Tài Khoản Hoặc Mật Khẩu Không Đúng',
        'login': 'Đăng Nhập',
        'username': 'Tên tài khoản',
        'password': 'Mật khẩu',
        'forgotPassword': "Quên mật khẩu?",
        'doNotHaveAnAccount': 'Bạn chưa có tài khoản?',
        'createNewAccount': 'Hãy tạo tài khoản mới',
        'notLoggedIn': 'Chưa đăng nhập',
    },
    'dashboard': {
        'voucher': 'Voucher',
        'total': 'Tổng',
        'totalMoney': "Tổng tiền",
        'vouches': 'Số Voucher',
        'needConfirm': "cần xác nhận",
        'isAboutToExpire': 'sắp hết hạn',
        'notUseYet': 'chưa sử dụng',
        'using': 'đang sử dụng',
        'chart': {
            'chartLine': {
                'overview': 'TỔNG QUAN',
                'voucherUsed': 'Voucher đã sử dụng',
                'month': 'Tháng',
                'week': 'Tuần'
            },
            'chartBar': {
                'performance': 'HIỆU SUẤT',
                'totalPurchased': 'Tổng số đã mua',
            },
            'chartDoughnut': {
                'overview': 'TỔNG QUAN',
                'const': 'Chi phí',
                'totalBudget': 'Tổng tiền',
                'voucherUsed': 'Voucher đã sử dụng',
                'voucherHasDelivered': 'Voucher đã chuyển',
                'VoucherNotUsed': 'Voucher chưa sử dụng',
                'voucher': 'Tổng voucher'
            }
        },
        'tabs': {
            'guide': 'Hướng dẫn'
        }
    },
    'errors': {
        'notFound': "Không tìm thấy trang này",
        'backToHomePage': 'Quay lại trang chủ'
    },
    'voucherManagement': {
        'all': "Tất cả",
        'waitForConfirmation': 'Chờ xác nhận',
        'using': 'Đang sử dụng',
        'notUseYet': 'Chưa sử dụng',
        'used': 'Đã sử dụng',
        'table': {
            'numericalOrder': "STT",
            'image': 'Hình ảnh',
            'voucherSerial': 'Số seri',
            'voucherName': 'Tên Voucher',
            'status': 'Trạng thái',
            'amount': 'Số lượng',
            'denominations': 'Mệnh giá',
            'totalMoney': "Tổng tiền",
            'amountUsed': 'SL sử dụng',
            'theRemainingAmount': 'SL còn lại',
            'moneySpent': 'Tiền đã sử dụng',
            'moneyRemaining': 'Tiền còn lại',
            'action': 'Action'
        },
        'noVoucher': 'Không có Voucher',
        'chooseDate': 'Chọn ngày',
        'period': 'Khoảng thời gian',
        'priceRange': 'Phạm vi giá',
        'status': {
            'all': 'Tất cả',
            'expired': 'Đã hết hạn',
            'used': 'Đã sử dụng',
            'waitingUse': 'Chờ xác nhận'
        }
    },
    'user': {
        'successfulActivation': 'Kích hoạt thành công',
        'failedActivation': 'Kích hoạt thất bại, vui lòng thử lại sau',
        'redirectLoginPage': 'Quay về trang đăng nhập sau 5 giây nữa',
        'resetPassword': {
            'linkNoLongerValid': 'Đường dẫn xác nhận không còn tồn tại.'
        }
    },
    'forgotPassword': {
        'passwordRetrieval': 'LẤY LẠI MẬT KHẨU',
        'enterEmail': 'Nhập email',
        'send': 'Gửi',
        'pleaseCheckEmailToChangePassword': 'Vui lòng kiểm tra email để lấy lại mật khẩu !'
    },
    'profile': {
        'title': 'Hồ sơ cá nhân',
        'username': 'Tên tài khoản',
        'emailAddress': 'Địa chỉ email',
        'fullName': 'Họ và tên',
        'phone': 'Điện thoại',
        'dateOfBirth': "Ngày sinh",
        'gender': 'Giới tính',
        'address': 'Địa chỉ',
        'genderType': {
            'male': 'Nam',
            'female': 'Nữ',
            'other': 'Khác'
        }
    },
    'lookUpVoucher': {
        'title': 'Tra cứu',
        'statusVoucher': 'TÌNH TRẠNG VOUCHER',
        'activationCode': 'Mã kích hoạt',
        'email': 'Email',
        'fullName': 'Họ và tên',
        'verification': 'Mã xác nhận',
        'customer': 'KHÁCH HÀNG',
        'voucherSerial': 'Số seri',
        'voucherName': 'Tên Voucher',
        'supplier': 'Nhà Cung Cấp',
        'price': 'Mệnh Giá',
        'effectiveDate': 'Ngày hiệu lực',
        'validDate': 'Hạn Sử Dụng',
        'expiredDate': 'Hạn sử dụng',
        'status': 'Tình trạng',
        'watchInformation': 'Xem thông tin',
        'seriNumber': 'S/N',
        'sentFrom': 'Gửi từ',
        'voucherPrice': 'Giá',
        'voucherDiscount': 'Giảm giá',
        'voucherSupplier': 'Cung cấp bởi',
        'startDate': 'Ngày bắt đầu',
        'endDate': 'Hạn sử dụng',
        'detailInfo': 'Thông tin chi tiết',
        'voucherInfo': 'Thông Tin Voucher',
        'invalidVoucherLinkMessage': 'Liên kết thông tin voucher không chính xác. Vui lòng kiểm tra lại liên kết hoặc dùng chức năng gởi lại thông tin voucher bạn đang sở hữu',
        'confirmAccessInfo': 'Xác thực thông tin truy cập',
        'inputCaptionEmailPhone': 'Nhập email hoặc số điện thoại nhận Voucher',
        'inputCaptionPhone': 'Nhập số điện thoại nhận Voucher',
        'inputHintEmail': 'E.g: your_email@sample.com',
        'inputHintPhone': 'E.g: 0912345678'
    },
    'evoucher': {
        'name': 'Voucher',
        'status': {
            'active': 'Đã kích hoạt',
            'inactive': 'Chưa phát hành',
            'new': 'Mới',
            'expired': 'Đã hết hạn',
            'issuing': 'Đang phát hành',
            'assigned': 'Khách hàng đã nhận',
            'used': 'Đã sử dụng',
            'waiting': 'Chờ khách hàng sử dụng',
            'using_expired': 'Hết thời hạn sử dụng',
            'distribution_expired': 'Hết thời hạn phát hành',
            'locked': 'Đang sử dụng',
            'activated': 'Khách hàng đã nhận',
            'notUseYet': 'Chưa sử dụng',
            'waitForConfirm': 'Chờ xác nhận',
            'transferred': 'Đã chuyển'
        },
        'voucherNotUseYet': 'Voucher chưa sử dụng',
        'voucherWaitingConfirm': 'Voucher chờ xác nhận',
        'voucherUsed': 'Voucher đã sử dụng',
        'voucherTransferred': 'Voucher đã chuyển',
        'used': 'Voucher đã được sử dụng',
        'confirmUsed': 'Xác nhận sử dụng',
        'description': 'Mô tả',
        'termConditions': 'Quy định & điều kiện',
        'remainQuantity': 'Số lượng còn lại',
        'promotion': 'Ưu đãi',
        'quantityIsOver': 'Số lượng đã hết',
        'addressUsage': 'Địa điểm sử dụng',
        'extraInfo': 'Thông tin thêm'
    },
    'voucherHistory': {
        'tableHistory': {
            'transactionHistory': 'Lịch sử giao dịch',
            'voucherSerial': 'Số seri',
            'personPerform': 'Người thực hiện',
            'rceiver': 'Người nhận',
            'executionDate': 'Ngày thực hiện',
            'description': 'Chi tiết'
        },
        'implementAgencies': 'Đơn vị thực hiện',
        'peopleAction': 'Người thực hiện',
        'receivingAgencies': 'Đơn vị nhận',
        'voucherUsageHistory': 'Lịch sử sử dụng voucher',
        'dateAction': 'Ngày thực hiện',
        'action': 'Hành động',
        'customerAction': 'Khách hàng thực hiện',
        'receivingCustomer': 'Khách hàng nhận',
        'type': {
            'create': 'Tạo voucher',
            'distribute': 'Phân phối tới Đại lý',
            'assigned': 'Phân phối tới khách hàng',
            'used': 'Xác nhận sử dụng trực tiếp voucher',
            'sendConfirmUsedRequest': 'Gửi yêu cầu sử dụng voucher tới khách hàng',
            'customerConfirmUsed': 'Khách hàng xác nhận sử dụng voucher',
            'customerCancelUsed': 'Khách hàng từ chối sử dụng voucher',
            'customerReturnUsed': 'Khách hàng hoàn trả voucher',
            'deleted': 'Xoá voucher',
            'usedFromThirdParties': 'Sử dụng từ bên thứ ba',
            'customerDeliveryVoucher': 'Khách hàng chuyển voucher',
            'usePromotionVoucher': 'Sử dụng voucher khuyến mãi',
            'createPromotionVoucher': 'Tạo voucher khuyến mãi',
            'approveReconciliation': 'Duyệt đối soát',
            'cancelReconciliation': 'Huỷ đối soát',
            'lockedVoucher': 'Khóa sử dụng voucher',
            'confirmUseLockedVoucher': 'Sử dụng voucher khóa sử dụng',
            'refundVoucher': 'Hoàn trả voucher khóa sử dụng',
            'adminSystemDeliveryVoucher': 'Chuyển voucher',
            'enableVoucher': 'Mở vô hiệu voucher',
            'disableVoucher': 'Vô hiệu voucher',
            'orderVoucher': 'Đặt hàng voucher',
            'cancelOrderVoucher': 'Hủy đặt hàng voucher',
            'confirmOrderVoucher': 'Xác nhân đặt hàng',
            'publishedStoreChannel': 'Đưa lên kênh bán hàng',
            'takebackStoreChannel': 'Gỡ khỏi kênh bán hàng',
            'purchaseOrder': 'Thanh toán đơn hàng',
            'cancelOrder': 'Hủy đơn hàng',
            'extendExpiration': 'Gia hạn thời gian sử dụng'
        },
        'description': {
            'undefined': 'Chưa xác định',
            'create': '[{entity}] phát hành {amount} vouchers',
            'distribute': '[{entity}] phân phối {amount} vouchers tới [{toEntity}]',
            'assigned': '[{entity}] phân phối {amount} voucher tới khách hàng [{customer}]',
            'used': '[{entity}] xác nhận sử dụng voucher của khách hàng [{customer}]',
            'sendConfirmUsedRequest': '[{entity}] gửi yêu cầu xác nhận sử dụng voucher tới khách hàng [{customer}]',
            'customerConfirmUsed': 'Khách hàng [{customer}] xác nhận sử dụng voucher qua email được gửi từ [{entity}]',
            'customerCancelUsed': '',
            'customerReturnUsed': '',
            'deleted': '[{entity}] xoá voucher',
            'usedFromThirdParties': '[{entity}] xác nhận sử dụng voucher của khách hàng [{customer}]',
            'customerDeliveryVoucher': 'Khách hàng [{owner}] cho/tặng voucher tới khách hàng [{customer}]',
            'usePromotionVoucher': '[{entity}] xác nhận sử dụng voucher khuyến mãi cho khách hàng [{customer}]',
            'createPromotionVoucher': '[{entity}] phát hành voucher ưu đãi',
            'approveReconciliation': '[{entity}] duyệt đối soát của [{requestEntity}]',
            'cancelReconciliation': '[{entity}] huỷ đối soát của [{requestEntity}]',
            'lockedVoucher': '[{entity}] khóa sử dụng voucher của khách hàng [{customer}]',
            'confirmUseLockedVoucher': '[{entity}] xác nhận sử dụng voucher khóa sử dụng',
            'refundVoucher': '[{entity}] hoàn trả voucher khóa sử dụng',
            'adminSystemDeliveryVoucher': 'Voucher được chuyển tới khách hàng [{customer}]',
            'enableVoucher': '[{entity}] hoàn trả voucher vô hiệu hóa',
            'disableVoucher': '[{entity}] vô hiệu hóa voucher của khách hàng [{customer}]',
            'orderVoucher': '[{storeChannel}]: voucher được đặt hàng với mã đơn hàng [{code}]',
            'cancelOrderVoucher': 'Đã hủy mã đơn hàng [{code}] từ [{storeChannel}]',
            'confirmOrderVoucher': 'Xác nhận thanh toán mã đơn hàng [{code}] từ [{storeChannel}]',
            'publishedStoreChannel': 'Đưa voucher lên kênh bán hàng [{storeChannel}]',
            'takebackStoreChannel': 'Gỡ voucher khỏi kênh bán hàng [{storeChannel}]',
            'purchaseOrder': 'Thanh toán mã đơn hàng [{code}] từ [{storeChannel}]',
            'cancelOrder': 'Đã hủy mã đơn hàng [{code}] từ [{storeChannel}]',
            'extendExpiration': 'Gian hạn thời gian sử dụng voucher'
        },
        'table': 'Bảng',
        'timeline': 'Mốc thời gian'
    },
    'entity': {
        'emailAlreadyExist': 'Email đã tồn tại !',
        'registerSuccessInactive': 'Đăng ký thành công, bạn có muốn truy cập trang đăng nhập?',
        'registerSuccess': 'Đăng ký thành công',
    },
    'transactionBetweenCustomer': {
        'transactionMulti': 'Chuyển voucher đã chọn',
        'transactionSingle': 'Chuyển voucher',
    },
    'sendVoucherInfoEmail': {
        'title': 'Xác nhận gửi email',
        'content': 'Bạn có chắc chắn muốn gửi thông tin voucher tới email này?',
        'success': {
            'title': 'Gửi email thành công!',
            'content': 'Thông tin voucher của bạn đã được gửi đi thành công !'
        },
        'error': {
            'title': 'Gửi email thất bại!'
        }
    },
    'usedVoucherPromotion': {
        'yourPromotionalEVoucherHasBeenUsedSuccessfully': 'E Voucher khuyến mãi của bạn đã được sử dụng thành công!',
    },
    'introduction': {
      'welcome': 'Chào đón đến với',
      'pagename': 'trang tra cứu thông tin E-voucher'
    },
    'help': {
        'lookupTitle': 'Hướng dẫn tra cứu thông tin Voucher',
        'lookupInfo': 'Tra cứu voucher chưa được sử dụng',
        'lookupOption1': 'Cách 1: Nhập số seri và mã xác nhận để tra cứu thông tin voucher',
        'lookupOption2': 'Cách 2: Nhập email và mã xác nhận để tra cứu thông tin voucher',
        'lookupOption3': 'Cách 3: Nhập số điện thoại và mã xác nhận để tra cứu thông tin voucher',
        'registrationTitle': 'Hướng dẫn đăng ký trở thành Nhà Cung Cấp',
        'registrationStep': 'Truy cập và đăng ký thông tin Nhà Cung Cấp tại {link}',
        'registrationHotline': 'Hoặc liên hệ hotline 090 969 0303 để được tư vấn',
        'usageTitle': 'Hướng dẫn sử dụng Voucher',
        'usageBuy': 'Mua voucher tại các điểm bán hàng của nhà cung cấp dịch vụ',
        'usageCheck': 'Nhận thông tin voucher qua email, sms, hoặc ứng dụng di động.{0}Đăng nhập vào ứng dụng để xem nhiều hơn  các thông tin của voucher, và có thể chuyển voucher cho tài khoản khác trên hệ thống',
        'usageExchange': 'Trao đổi với nhân viên của nhà cung cấp dịch vụ để được tư vấn sử dụng voucher cho các sản phẩm và dịch vụ',
        'usageUsed': 'Cung cấp số seri và mã kích hoạt voucher hoặc đưa mã QR của voucher cho nhân viên để sử dụng sản phẩm và dịch vụ'
    },
    'footer': {
        'contact': 'Liên Hệ',
        'mobileApp': 'Tải ứng dụng di động',
        'connectUs': 'Kết nối với Avatar Technologies',
        'introduction': 'Hướng dẫn',
        'registerSupplier': 'Đăng ký trở thành nhà cung cấp'
    },
    'location': {
        'longitude': 'Kinh độ',
        'latitude': 'Vĩ độ',
        'province': 'Tỉnh / Thành Phố',
        'district': 'Quận / Huyện',
        'ward': 'Phường / Xã',
        'address': 'Địa chỉ',
        'addressTitle': 'Chỉnh sửa địa chỉ'
      },
    'socialNetwork': {
      'notiAddSocialAccountLink': 'Bạn có chắc chắn muốn thêm liên kết tài khoản {0}?',
      'notiConfirmCreateAccountWithGoogle': 'Bạn có chắc chắn muốn tạo tài khoản với thông tin tài khoản google này?'
    }
}